"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/icon/style/index.js
// module id = 47
// module chunks = 1